<!-- 页面内容 -->
<template>
	<div class=""> </div>
</template>

<script>
export default {
	data() {
		return {}
	},
	created() { },
	methods: {},
}
</script>

<style lang='scss' scoped></style>